var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Link } from "react-router-dom";
import { Button, Dimmer, Form, Grid, Header, Input, Loader, Message, Modal, Segment, Select, Table, TextArea } from "semantic-ui-react";
import { AppPaths } from "../AppConfig";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { Help } from "../Help";
import KitDisplay from "../kit/rna-fish/KitDisplay";
import ProfileEditForm from "../ProfileEditForm";
import { addressGridRows } from "../ProfilePage";
import { getWithAuthn, postWithAuthn } from "../RequestHelpers";
import { displayLocalTimestamp } from "./AllOrdersPage";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UpdateDiscountsModal from "./UpdateDiscountsModal";
var SingleUserPage = /** @class */ (function (_super) {
    __extends(SingleUserPage, _super);
    function SingleUserPage(props) {
        var _this = _super.call(this, props) || this;
        _this.editMetadataModal = function (user) {
            var renderEditMetadata = function (props) {
                return React.createElement(EditMetadataModal, __assign({ userId: _this.props.match.params.id, 
                    // can't invoke this until the response is loaded anyway...
                    initialNotes: user.notes, initialOnOrderEmails: user.onOrderEmails, initialReferringUserReferralId: user.referredBy === null ? "" : (user.referredBy._type === "PERSONAL" ? user.referredBy.id : "") }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit metadata', labelPosition: 'left' }) },
                React.createElement(Modal.Header, null, "Edit Metadata"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditMetadata, successMessage: 'Metadata saved' })));
        };
        _this.editUserStatusModal = function (user) {
            var renderEditUserStatus = function (props) {
                return React.createElement(EditUserStatusModal, __assign({ user: user }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: user.userStatus === 'LEGACY' ? 'Remove v3.0 Access' : 'Grant v3.0 Access', labelPosition: 'left', size: 'mini' }) },
                React.createElement(Modal.Header, null, "Confirm Edit"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderEditUserStatus, successMessage: 'Status changed' })));
        };
        _this.loadUser = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn("/admin/users/id/" + encodeURIComponent(_this.props.match.params.id))
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load user: " + rej);
                });
            });
        };
        _this.clearQboId = function () {
            _this.setState({ loading: true }, function () {
                postWithAuthn("/admin/users/id/" + encodeURIComponent(_this.props.match.params.id) + "/clear-qbo-id")
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.loadUser();
                        return;
                    }
                    else {
                        _this.setState({ loading: false });
                        return undefined;
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load user: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false,
        };
        return _this;
    }
    SingleUserPage.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: 'non-header-portion' },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.error &&
                    React.createElement(Message, { negative: true }, "User could not be loaded."),
                this.state.response &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Header, null,
                            "User ",
                            this.state.response.user.id),
                        React.createElement(Grid, { className: 'tight-rows', width: 4 },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Name"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.name)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Email"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.email)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Organization"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.organization)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Research group"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.researchGroup)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Phone"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.phone)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Category"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.category)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "QuickBooks Customer Id"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    this.state.response.user.qboCustomerId,
                                    " ",
                                    this.state.response.user.qboCustomerId && React.createElement(React.Fragment, null,
                                        "| ",
                                        React.createElement(Modal, { closeIcon: true, closeOnDimmerClick: true, closeOnDocumentClick: true, trigger: React.createElement(Button, { labelPosition: 'left', label: 'Clear Quickbooks ID', negative: true, icon: 'x' }) },
                                            React.createElement(Modal.Header, null, "Are you sure you want to clear the users Quickbooks ID?"),
                                            React.createElement(Modal.Content, null,
                                                React.createElement(Button, { onClick: this.clearQboId, labelPosition: 'left', label: 'Clear Quickbooks ID', negative: true, icon: 'x' })))))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Notes"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    React.createElement("pre", { className: 'text-with-whitespace' }, this.state.response.user.notes))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Emails when order is placed"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.onOrderEmails.length > 0
                                    ? this.state.response.user.onOrderEmails.map(function (row) { return row.email; }).join(", ")
                                    : React.createElement("i", null, "None"))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Referred By (Free Text)"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.referredByFreeText)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Created at"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayLocalTimestamp(this.state.response.user.createdAt))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "v3.0 access"),
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                                    this.state.response.user.userStatus === 'LEGACY' ? 'Granted' : 'No',
                                    "\u00A0\u00A0",
                                    this.editUserStatusModal(this.state.response.user))),
                            React.createElement(Header, null, "Referral"),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Referral Id"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.usersReferral.referralId.id)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Referral Link"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                    React.createElement("a", { href: this.state.response.user.usersReferral.bitlyLink }, this.state.response.user.usersReferral.bitlyLink))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null, this.editMetadataModal(this.state.response.user)))),
                        React.createElement(Header, null, "Orders"),
                        React.createElement(Table, { striped: true, celled: true },
                            React.createElement(Table.Header, null,
                                React.createElement(Table.Row, null,
                                    React.createElement(Table.HeaderCell, null, "Id"),
                                    React.createElement(Table.HeaderCell, null, "Payment Status"),
                                    React.createElement(Table.HeaderCell, null, "Production Status"),
                                    React.createElement(Table.HeaderCell, null, "Created"))),
                            React.createElement(Table.Body, null, this.state.response.orders.map(function (o, index) {
                                return React.createElement(Table.Row, { key: index },
                                    React.createElement(Table.Cell, null,
                                        React.createElement(Link, { to: AppPaths.ADMIN_ORDER_BASE + "/" + o.id }, o.id)),
                                    React.createElement(Table.Cell, null, o.pmtStatus),
                                    React.createElement(Table.Cell, null, o.prodStatus),
                                    React.createElement(Table.Cell, null, displayLocalTimestamp(o.createdAt)));
                            }))),
                        React.createElement(Header, null, "Shipping Address"),
                        React.createElement(Grid, { className: 'tight-rows' }, addressGridRows(this.state.response.user.shippingAddress, KitDisplay.labelWidth, KitDisplay.valueWidth)),
                        React.createElement(Header, null, "Billing Address"),
                        React.createElement(Grid, { className: 'tight-rows' },
                            addressGridRows(this.state.response.user.billingAddress, KitDisplay.labelWidth, KitDisplay.valueWidth),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Billing Email"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.billingEmail)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Billing Phone"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, this.state.response.user.billingPhone)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(Modal, { closeIcon: true, onClose: this.loadUser, trigger: React.createElement(Button, { icon: 'edit', label: 'Edit profile', labelPosition: 'left' }) },
                                        React.createElement(Modal.Header, null, "Update profile"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(ProfileEditForm, { buttonIcon: 'save', buttonLabel: 'Save changes', disableOnSuccess: true, endpoint: "/admin/users/id/" + encodeURIComponent(this.state.response.user.id), hideOnSuccess: true, includePassword: false, initialProfile: this.state.response.user, initialCategory: this.state.response.user.category, successHeader: 'Profile updated', successMessage: React.createElement(React.Fragment, null), legalInput: false, categoryInput: true, referredByInput: false, sendSignUpGaEvent: false })))))),
                        React.createElement(Header, null, "Discounts"),
                        React.createElement(Grid, { className: 'tight-rows' },
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH (v3.0) Probe - catalog"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaFishProbeSetCatalog))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH (v3.0) Probe - custom"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaFishProbeSetCustom))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH / IF (v3.0) Amplifier"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaFishAmplifier))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-FISH (v3.0) Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaFishBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "IF Probe"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.ihc2Probe))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "IF Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.ihc2Buffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Probe - catalog"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaCishProbeSetCatalog))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Probe - custom"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaCishProbeSetCustom))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Amplifier"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaCishAmplifier))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "RNA-ISH Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.rnaCishBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH Probe - catalog"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishProbeSetCatalog))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH Probe - custom"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishProbeSetCustom))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH / IF Amplifier"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishAmplifier))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold RNA-FISH Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldRnaFishBuffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold IF Probe"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldIhc2Probe))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold IF Buffers"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.goldIhc2Buffers))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Manual Pro Detect"),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, formatDiscount(this.state.response.user.discounts.manualProDetect))),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement(Modal, { closeIcon: true, trigger: React.createElement(Button, { icon: 'dollar sign', label: 'Update discounts', labelPosition: 'left' }), onClose: this.loadUser },
                                        React.createElement(Modal.Header, null, "Update discounts"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(Modal.Description, null, "Discounts can be either blank for no discount or a number in (0, 100] with up to 3 fractional digits."),
                                            React.createElement(UpdateDiscountsModal, { initialValues: this.state.response.user.discounts, userId: this.props.match.params.id })))))))));
    };
    SingleUserPage.prototype.componentDidMount = function () {
        this.loadUser();
    };
    return SingleUserPage;
}(React.PureComponent));
export default SingleUserPage;
var formatDiscount = function (d) {
    if (d.length > 0) {
        return d + "%";
    }
    else {
        return '-';
    }
};
var EditMetadataModal = /** @class */ (function (_super) {
    __extends(EditMetadataModal, _super);
    function EditMetadataModal(props) {
        var _this = _super.call(this, props) || this;
        _this.addBlankEmailRow = function () {
            _this.setState(function (prevState) { return ({
                onOrderEmails: prevState.onOrderEmails.concat({ email: '', templateId: '' })
            }); });
        };
        _this.submit = function () {
            if (_this.state.referringUserReferralId.trim() !== "") {
                _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/metadata", {
                    notes: _this.state.notes,
                    onOrderEmails: _this.state.onOrderEmails,
                    referringUserReferralId: _this.state.referringUserReferralId
                });
            }
            else {
                _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.userId) + "/metadata", {
                    notes: _this.state.notes,
                    onOrderEmails: _this.state.onOrderEmails,
                });
            }
        };
        _this.onNotesChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({ notes: value });
        };
        _this.onReferralIdChange = function (_, data) {
            var value = data.value;
            _this.setState({ referringUserReferralId: value });
        };
        _this.loadAllUsers = function () {
            getWithAuthn("/admin/users/referrals/all")
                .then(function (resp) {
                return resp.json();
            })
                .then(function (profiles) {
                _this.setState({
                    users: profiles.users
                });
            });
        };
        _this.state = {
            notes: _this.props.initialNotes,
            onOrderEmails: _this.props.initialOnOrderEmails,
            referringUserReferralId: _this.props.initialReferringUserReferralId,
            users: []
        };
        return _this;
    }
    EditMetadataModal.prototype.componentDidMount = function () {
        this.loadAllUsers();
    };
    EditMetadataModal.prototype.render = function () {
        var _this = this;
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/notes', errors: this.props.state.errors, required: true, labelContent: 'Notes' },
                React.createElement(TextArea, { placeholder: '...', onChange: this.onNotesChange, value: this.state.notes })),
            React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/referredBy', labelContent: 'Referred By' },
                React.createElement(Select, { options: this.state.users.map(function (u) {
                        return {
                            text: u.name + " (" + u.accountEmail + ")",
                            description: u.usersReferral.referralId.id,
                            value: u.usersReferral.referralId.id
                        };
                    }), search: true, placeholder: 'Please enter referral id', onChange: this.onReferralIdChange, value: this.state.referringUserReferralId })),
            React.createElement(Form.Field, null,
                React.createElement("label", null,
                    "Emails to send when the user places an order ",
                    React.createElement(Help, null, "The template ids are SendGrid template ids")),
                React.createElement(Segment, null,
                    React.createElement(Grid, { columns: 3 },
                        this.state.onOrderEmails.length === 0 ?
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, null,
                                    React.createElement("i", null, "None"))) : React.createElement(React.Fragment, null),
                        this.state.onOrderEmails.map(function (ooe, index) {
                            var onEmailChange = function (_, data) {
                                var email = data.value;
                                _this.setState(function (prevState) {
                                    var newEmails = prevState.onOrderEmails.slice();
                                    newEmails[index] = {
                                        email: email,
                                        templateId: newEmails[index].templateId
                                    };
                                    return { onOrderEmails: newEmails };
                                });
                            };
                            var onTemplateIdChange = function (_, data) {
                                var templateId = data.value;
                                _this.setState(function (prevState) {
                                    var newEmails = prevState.onOrderEmails.slice();
                                    newEmails[index] = {
                                        email: newEmails[index].email,
                                        templateId: templateId
                                    };
                                    return { onOrderEmails: newEmails };
                                });
                            };
                            var remove = function () {
                                _this.setState(function (prevState) {
                                    var copy = prevState.onOrderEmails.slice();
                                    copy.splice(index, 1);
                                    return ({
                                        onOrderEmails: copy
                                    });
                                });
                            };
                            return React.createElement(Grid.Row, { key: index },
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.props.state.errors, errorPath: "/onOrderEmails/" + index + "/email", labelContent: "Email #" + (index + 1) },
                                        React.createElement(Input, { onChange: onEmailChange, value: ooe.email }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(FieldWithErrorDisplay, { errors: _this.props.state.errors, errorPath: "/onOrderEmails/" + index + "/templateId", labelContent: "Template id #" + (index + 1) },
                                        React.createElement(Input, { style: { display: 'inline-box' }, onChange: onTemplateIdChange, value: ooe.templateId }))),
                                React.createElement(Grid.Column, null,
                                    React.createElement(Form.Field, null,
                                        React.createElement("label", null, "\u00A0"),
                                        React.createElement(Button, { icon: 'x', label: 'Remove', labelPosition: 'left', onClick: remove, negative: true }))));
                        }),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null,
                                React.createElement(Button, { icon: 'add', label: 'Add a row', labelPosition: 'left', onClick: this.addBlankEmailRow })),
                            React.createElement(Grid.Column, null))))),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Save metadata', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return EditMetadataModal;
}(React.PureComponent));
var EditUserStatusModal = /** @class */ (function (_super) {
    __extends(EditUserStatusModal, _super);
    function EditUserStatusModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onConfirm = function () {
            _this.props.postRequest("/admin/users/id/" + encodeURIComponent(_this.props.user.id) + "/user-status", {
                newUserStatus: _this.props.user.userStatus === 'LEGACY' ? 'NON_LEGACY' : 'LEGACY'
            });
        };
        return _this;
    }
    EditUserStatusModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement("p", { style: { fontWeight: 'bold', whiteSpace: "pre-line" } },
                "Are you sure you want to ",
                this.props.user.userStatus === 'LEGACY' ? 'remove' : 'grant',
                " v3.0 access for ",
                this.props.user.name,
                "?"),
            React.createElement(Button, { className: 'fish-button', disabled: this.props.state.loading || this.props.state.success, icon: 'save', label: 'Confirm', labelPosition: 'left', onClick: this.onConfirm, positive: true }));
    };
    return EditUserStatusModal;
}(React.PureComponent));
//# sourceMappingURL=SingleUserPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SingleUserPage.js
// module id = 1310
// module chunks = 0